// To parse this data:
//
//   import { Convert, ListMembersResponse } from "./file";
//
//   const listMembersResponse = Convert.toListMembersResponse(json);

export interface ListMembersResponse {
	totalFilteredRecords?: number;
	pageItems?: Member[];
}

export interface Member {
	id: number;
	accountNo: string;
	externalId: string;
	status?: LegalForm;
	subStatus?: SubStatus;
	active?: boolean;
	activationDate?: number[];
	firstname?: string;
	middlename?: string;
	lastname?: string;
	displayName?: string;
	emailAddress?: string;
	mobileNo?: string;
	dateOfBirth?: number[];
	gender?: ClientClassification;
	clientType?: ClientClassification;
	clientClassification?: ClientClassification;
	isStaff?: boolean;
	officeId?: number;
	officeName?: string;
	staffId?: number;
	staffName?: string;
	timeline?: Timeline;
	legalForm?: LegalForm;
	clientNonPersonDetails?: ClientNonPersonDetails;
}

export interface ClientClassification {
	id?: number;
	name?: string;
	active?: boolean;
	mandatory?: boolean;
}

export interface ClientNonPersonDetails {
	constitution?: SubStatus;
	mainBusinessLine?: SubStatus;
}

export interface SubStatus {
	active?: boolean;
	mandatory?: boolean;
}

export interface LegalForm {
	id?: number;
	code?: string;
	value?: string;
}

export interface Timeline {
	submittedOnDate?: number[];
	submittedByUsername?: string;
	submittedByFirstname?: string;
	submittedByLastname?: string;
	activatedOnDate?: number[];
	activatedByUsername?: string;
	activatedByFirstname?: string;
	activatedByLastname?: string;
}

// Converts JSON strings to/from your types
export class ConvertListMembersResponse {
	public static toListMembersResponse(json: string): ListMembersResponse {
		return JSON.parse(JSON.stringify(json));
	}

	public static listMembersResponseToJson(value: ListMembersResponse): string {
		return JSON.stringify(value);
	}
}
